import { ApiResponse, InitOverrideFunction, TermsOfUseApi, UploadTermsOfUsePostRequest } from "../../../@api";

import { ITermsOfUse } from "../../components/Pages/AdminArea/TermsOfUseTab/TermsOfUseTable/TermsOfUseTable";
import { IStoreContext } from "../../stores/StoreContext";
import { TermsOfUseApiService } from "../ApiServices/TermsOfUseApiService";
import GenericService from "../GenericService";

export class TermsOfUseService extends GenericService<TermsOfUseApi, TermsOfUseApiService> {
  constructor(storeContext: IStoreContext) {
    super(storeContext, TermsOfUseApi, TermsOfUseApiService);
  }

  public async shouldPersistAnyUserActions(
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<string | null | undefined> {
    const result = await this.apiService.getNewestTermsOfUse(initOverrides);
    return result?.fileBase64 ?? undefined;
  }

  public async getCurrentTermsOfUse(): Promise<string | null> {
    const result = await this.apiService.getNewestTermsOfUse();

    return result?.fileBase64 ?? null;
  }

  public async uploadTermsOfUse(
    request: UploadTermsOfUsePostRequest,
    overrides?: RequestInit | InitOverrideFunction,
  ): Promise<ApiResponse<string>> {
    return this.apiService.uploadTermsOfUsePostRaw(request, overrides);
  }

  public acceptCurrentTermsOfUsePatch(initOverrides?: RequestInit | InitOverrideFunction): Promise<string> {
    return this.apiService.acceptCurrentTermsOfUsePatch(initOverrides);
  }

  public async getAllTermsOfUse(): Promise<ITermsOfUse[]> {
    const result = await this.apiService.termsOfUseGetAll();

    if (!result || !Array.isArray(result.termsOfUses)) {
      return [];
    }

    return result.termsOfUses;
  }

  public async getTermsOfUseById(id: string): Promise<string | null> {
    const result = await this.apiService.termsOfUseGetById({
      termsOfUseId: id,
    });

    return result?.fileBase64 ?? null;
  }

  public async deleteTermsOfUse(id: string): Promise<void> {
    await this.apiService.deleteTermsOfUseFile({ termsOfUseId: id });
  }
}
